import { Store } from '@ngrx/store';
import { BehaviorSubject } from 'rxjs';
import { setDeserializedAppState } from 'Angular/state/app-state/app-state.actions';
import { FolderableAjaxService } from './folderable-ajax.service';
import { AppStateManager } from 'Angular/services/app-state-manager.service';
import * as i0 from "@angular/core";
import * as i1 from "Angular/services/app-state-manager.service";
import * as i2 from "./folderable-ajax.service";
import * as i3 from "@ngrx/store";
export class SelectedFolderableService {
    constructor(appStateManager, folderableAjaxService, store) {
        this.appStateManager = appStateManager;
        this.folderableAjaxService = folderableAjaxService;
        this.store = store;
        this.selectedFolderable = new BehaviorSubject(null);
        this.selectedFolderable$ = this.selectedFolderable.asObservable();
        this.folderableSubscription = null;
    }
    getSelection() {
        return this.selectedFolderable.getValue();
    }
    selectFolderable(itemId) {
        if (this.folderableSubscription)
            this.folderableSubscription.unsubscribe();
        this.folderableSubscription = this.folderableAjaxService
            .getFolderableItem(this.RESOURCE_TYPE, itemId)
            .subscribe({
            next: (response) => {
                // Emit the selected folderable before updating app state.
                // If `selectedFolderable` is used in `mapStateToComponent` or any subscriber to state changes,
                // values in `selectedFolderable` will be up to date.
                this.selectedFolderable.next(response);
                this.updateAppState(response.item);
            },
            error: () => {
                this.clearSelection();
            },
        });
    }
    /**
     * Update the selected folderable item to avoid making a backend request when the info is already available.
     * Only use this when you know the updates are consistent with the backend value. If you are not sure, use the
     * `selectFolderable` method instead.
     * @param overrides
     */
    updateSelectedFolderableItem(overrides) {
        const folderable = this.selectedFolderable.getValue();
        if (folderable === null)
            throw new Error('Cannot update selected folderable because it does not exist.');
        const newFolderable = {
            ...folderable,
            item: {
                ...folderable.item,
                ...overrides,
            },
        };
        this.selectedFolderable.next(newFolderable);
    }
    clearSelection() {
        if (this.selectedFolderable.getValue() === null)
            return;
        this.selectedFolderable.next(null);
    }
    updateAppState(folderableItem) {
        this.store.dispatch(setDeserializedAppState({
            deserializedAppState: {
                ...this.appStateManager.deserialize(folderableItem.state),
                [this.ITEM_ID_SLICE_KEY]: folderableItem.id,
            },
        }));
    }
}
SelectedFolderableService.ɵfac = function SelectedFolderableService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SelectedFolderableService)(i0.ɵɵinject(i1.AppStateManager), i0.ɵɵinject(i2.FolderableAjaxService), i0.ɵɵinject(i3.Store)); };
SelectedFolderableService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SelectedFolderableService, factory: SelectedFolderableService.ɵfac });
